<template>
	<div class="shipper-settings">
		<div class="control-group">
			<div class="inner">
				<label class="control-label">URL:</label>
				<div class="controls">
					<div class="field">
                        <div class="field">
                            <p-input-text v-model="shipperSettings.url" />
                        </div>
					</div>
				</div>
			</div>
		</div>

        <div class="control-group">
			<div class="inner">
				<label class="control-label">Login:</label>
				<div class="controls">
					<div class="field">
						<p-input-text 
                            v-model="shipperSettings.email" 
                            placeholder="Email"
                        />
					</div>
					<gutter size="10px" />
					<div class="field">
						<p-password
                            v-model="shipperSettings.password"
                            name="password"
                            :feedback="false"
                            toggle-mask
                            aria-labelledby="password"
                            placeholder="Password"
                        />
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: 'ShipperSettingsSoffront',
	props: {
		modelValue: {
			type: Object,
			default() {
				return {
					url: '',
                    email: '',
                    password: '',
				};
			},
		},
	},
	computed: {
		shipperSettings: {
			get() {
				return this.modelValue;
			},
			set(new_value) {
				this.$emit('update:modelValue', new_value);
			},
		},
	},
};
</script>

<style lang="less"></style>
